<div class="shortcuts" [ngClass]="!searchService.expanded ? 'expanded':''">
  <div class="shortcuts__container">
    <div *ngFor="let shortcut of this.shortcutsService.shortcuts" class="assigned">
      <a (click)="callAction(shortcut)">{{ shortcut.name}}</a>
      <span (click)="checkDelete(shortcut)"></span>
    </div>
    <div class="new">
      <a (click)="openShortcutsList()">+</a>
    </div>
  </div>
</div>
